import Radio from "~/common/components/Radio";
import { type ItemDef } from "~/common/types";
import { Box, Stack, Typography } from "~/common/mui";

interface RadioSwitchProps {
  value: string;
  onChange: (newVal: string) => void;
  options: ItemDef[];
  className?: string;
  label?: string;
}

export const RadioSwitch = ({ className, label, options, value, onChange }: RadioSwitchProps) => {
  return (
    <Box className={className}>
      {label && (
        <Typography variant="labelLarge" sx={{ mb: 2.5 }}>{label}</Typography>
      )}
      <Stack direction="row" spacing={4}>
        {options.map((option) => (
          <Box sx={{ display: "flex", "& .Mui-disabled": { color: "divider !important" }, "& .Mui-checked.Mui-disabled": { color: "#99d0b1 !important" } }} onClick={() => onChange(option.code)}>
            <Radio active={value === option.code} className={"icon-margin"} />
            <span>{option.label}</span>
          </Box>
        ))}
      </Stack>
    </Box>
  );
};
